import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/close.png'


const _withScopeId = n => (_pushScopeId("data-v-1dc92b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["show"]
const _hoisted_2 = { class: "package-content" }
const _hoisted_3 = { class: "package-content-list" }
const _hoisted_4 = { class: "scroll-box" }
const _hoisted_5 = { class: "package-item-main" }
const _hoisted_6 = { class: "main-title" }
const _hoisted_7 = { class: "main-time" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-content-img" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-content__btn" }, null, -1))

import { ref, onActivated, reactive, onBeforeUnmount } from 'vue'
import { Overlay } from 'vant'
import { getWaitCheckRightsPackage } from '@/api/member'
import { splitTimeDate } from '@/utils/common'
import MImage from '@/components/MImage/MImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PopEquityPackage',
  setup(__props) {

const equityPackageVisable = ref(false)
const state = reactive({
  list: [{}],
})

const fetchWaitCheckRightsPackage = async () => {
  const { ret, dataList } = await getWaitCheckRightsPackage()
  state.list = dataList || []
  if (ret === 100) {
    if (dataList?.length > 0) {
      equityPackageVisable.value = true
    } else {
      equityPackageVisable.value = false
    }
  }
}

onActivated(() => {
  equityPackageVisable.value = false
  fetchWaitCheckRightsPackage()
})

onBeforeUnmount(() => {
  equityPackageVisable.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (equityPackageVisable.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pop-mask",
        show: equityPackageVisable.value
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "package-item",
                  key: item?.id
                }, [
                  _createVNode(MImage, {
                    class: "package-item__cover",
                    src: item.packageIcon
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.packageName), 1),
                    _createElementVNode("div", _hoisted_7, " 有效期限：" + _toDisplayString(_unref(splitTimeDate)(item.endTime, {
                    format: 'yyyy-mm-dd',
                    split: '/',
                  })), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_8,
          _createVNode(_component_router_link, { to: "/user/equitypackage/list" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("img", {
          class: "overlay-close-btn",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (equityPackageVisable.value = false))
        })
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})